module.exports = __webpack_public_path__ + "static/media/ben_marshall.f5e2d020.png";